<template>
<div class="tempDownload max-width">

	<v-afficheSidebar></v-afficheSidebar>

	<div class='td_model'>
		<!-- <a class='td_line font-16 color' 
		href='./static/彩航-本厂标准刀模201910.cdr' 
		download='' 
		>彩航-信封_利是封_文件袋_筷子套_房卡套-标准刀模201910
		</a> -->

		<a class='td_mod_view font-hover' 
		   href='./static/xinfengDaomo1.rar'
		   >
			<div class='td_mod_vi_name'>信封刀模文件下载</div>
			<!-- <div class='td_mod_vi_font font-12'>下载</div> -->
			<img class='td_mod_vi_icon' src='@/assets/icon/download.png' />
		</a>
		<a class='td_mod_view font-hover'
		   href='./static/lishifengDaomo.rar' 
		   >
			<div class='td_mod_vi_name'>红包刀模文件下载</div>
			<img class='td_mod_vi_icon' src='@/assets/icon/download.png' />
		</a>
		<a class='td_mod_view font-hover' 
		   href='./static/fileDaomo.rar' 
		   >
			<div class='td_mod_vi_name'>文件袋刀模文件下载</div>
			<img class='td_mod_vi_icon' src='@/assets/icon/download.png' />
		</a>
		<a class='td_mod_view font-hover' 
		   href='./static/kuaizitaoDaomo.rar' 
		   >
			<div class='td_mod_vi_name'>筷子套刀模文件下载</div>
			<img class='td_mod_vi_icon' src='@/assets/icon/download.png' />
		</a>
		<a class='td_mod_view font-hover' 
		   href='./static/fangkataoDaomo.rar' 
		   >
			<div class='td_mod_vi_name'>房卡套刀模文件下载</div>
			<img class='td_mod_vi_icon' src='@/assets/icon/download.png' />
		</a>
        <a class='td_mod_view font-hover' 
		   href='./static/kuaidifeng.zip' 
		   >
			<div class='td_mod_vi_name'>快递封套刀模文件下载</div>
			<img class='td_mod_vi_icon' src='@/assets/icon/download.png' />
		</a>
		<a class='td_mod_view font-hover' 
		   href='./static/tjbgDaomo.rar' 
		   >
			<div class='td_mod_vi_name'>体检报告刀模下载</div>
			<img class='td_mod_vi_icon' src='@/assets/icon/download.png' />
		</a>
		<a class='td_mod_view font-hover' 
		   href='./static/ftDaomo.rar' 
		   >
			<div class='td_mod_vi_name'>封套刀模文件下载</div>
			<img class='td_mod_vi_icon' src='@/assets/icon/download.png' />
		</a>
    <!-- <div class='td_preview'>
      <img class='td_previ_img' src='@/assets/banner/daomo_preview.jpg' />
    </div> -->
	</div>

</div>
</template>

<script>

export default {
	name: 'tempDownload',
	components: {
	},
	data() {
		return {
		}
	},
	methods: {
		func_download() {
			/* const userInfo = this.$parent.$parent.selectStorageChange('g_userInfo');
			if (userInfo && userInfo.userid) {
				var resultExcel = await orderListExport(userInfo.userid, this.page, this.pageSize, flag, this.startDate, this.endDate, this.queryString);
				const url = process.env.api;

				//创建a标签
				let elementA = document.createElement('a');

				//文件的名称为时间戳加文件名后缀
				elementA.download = +new Date() + '.xls';
				elementA.style.display = 'none';

				//生成一个blob二进制数据, 内容为json数据
				// const blob = new Blob([JSON.stringify(resultExcel)]);
				const blob = new Blob([resultExcel], {type:'APPLICATION/OCTET-STREAM;charset=utf-8'});

				//生成一个指向blob的URL地址, 并赋值给a标签的href属性
				elementA.href = URL.createObjectURL(blob);
				document.body.appendChild(elementA);
				elementA.click();
				document.body.removeChild(elementA);
			} */
		}
	},
	mounted() {
	}
}
</script>
<style src='@/style/tempDownload.css' scoped></style>



// WEBPACK FOOTER //
// src/pages/TempDownload.vue